import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import React, { useState } from "react";
import SharedPreferences from "../../core/utils/SharedPreferences";
import { STORAGE_KEYS } from "../../data/constant/Constants";
import { ROUTE_ENDPOINTS } from "../../data/constant/RouteConstants";
import { HomeView } from "../pages/home/HomeView";
import { LandingView } from "../pages/landing/LandingView";
import LoginView from "../pages/auth/login/LoginView";
import SignupView from "../pages/auth/signup/SignupView";
import { GameView } from "../pages/game/GameView";
import { GameFinishedView } from "../pages/game/GameFinishedView";
import { PaymentStatusView } from "../pages/paymentStatus/PaymentStatusView";
import { Backdrop, Box, CircularProgress, Stack } from "@mui/material";
import { COLOR_BLACK, COLOR_WHITE } from "../../data/colors/Colors";
import { CustomTextView } from "../component/CustomTextView";
import { useTranslation } from "react-i18next";
import { ResetPasswordView } from "../pages/auth/resetPassword/ResetPasswordView";
import { ForgotPasswordView } from "../pages/auth/forgotPassword/ForgotPasswordView";
import { UnlockCodeView } from "../pages/unlockCode/UnlockCodeView";
import { QRCodeAnswersView } from "../pages/qrcode/answers/QRCodeAnswersView";

export default function Router() {
  const getShowLoading = () =>
    SharedPreferences.getBoolean(STORAGE_KEYS.SHOW_LOADING) == true;
  const getLoginToken = () =>
    SharedPreferences.getString(STORAGE_KEYS.TOKEN) !== null;

  const [isLoggedIn, setIsLoggedIn] = useState(getLoginToken());

  const [showLoading, setShowLoading] = useState(getShowLoading());

  window.addEventListener(STORAGE_KEYS.TOKEN, () => {
    setIsLoggedIn(getLoginToken());
  });

  window.addEventListener(STORAGE_KEYS.SHOW_LOADING, () => {
    setShowLoading(getShowLoading());
  });

  function PublicRoute(path: string, element: React.ReactNode) {
    return (
      <Route
        path={path}
        element={
          isLoggedIn ? <Navigate to={ROUTE_ENDPOINTS.HOME_PLAY} /> : element
        }
      />
    );
  }

  function AuthRoute(path: string, element: React.ReactNode) {
    return (
      <Route
        path={path}
        element={
          isLoggedIn ? element : <Navigate to={ROUTE_ENDPOINTS.LANDING} />
        }
      />
    );
  }

  const { t } = useTranslation();

  return (
    <Box>
      <Backdrop
        open={showLoading}
        sx={{
          color: COLOR_BLACK,
          zIndex: (theme) => theme.zIndex.drawer + 999,
        }}
      >
        <Stack alignItems={"center"} gap={2}>
          <CircularProgress sx={{ color: COLOR_WHITE }} size={40} />
          <CustomTextView
            text={t("loading")}
            textColor={COLOR_WHITE}
            variant="h6"
            fontWeight="bold"
          />
        </Stack>
      </Backdrop>
      <BrowserRouter>
        <Routes>
          {PublicRoute(ROUTE_ENDPOINTS.LANDING, <LandingView />)}
          {PublicRoute(ROUTE_ENDPOINTS.LOGIN, <LoginView />)}
          {PublicRoute(ROUTE_ENDPOINTS.SIGNUP, <SignupView />)}
          {PublicRoute(ROUTE_ENDPOINTS.RESET_PASSWORD, <ResetPasswordView />)}
          {PublicRoute(ROUTE_ENDPOINTS.FORGOT_PASSWORD, <ForgotPasswordView />)}
          {AuthRoute(ROUTE_ENDPOINTS.HOME, <HomeView />)}
          {AuthRoute(ROUTE_ENDPOINTS.GAME, <GameView />)}
          {AuthRoute(ROUTE_ENDPOINTS.GAME_FINISHED, <GameFinishedView />)}
          {AuthRoute(ROUTE_ENDPOINTS.UNLOCK_CODE, <UnlockCodeView />)}
          <Route
            path={ROUTE_ENDPOINTS.PAYMENT_STATUS}
            element={<PaymentStatusView />}
          />
          <Route
            path={`${ROUTE_ENDPOINTS.QRCODE_ANSWERS}/:id`}
            element={<QRCodeAnswersView />}
          />
          <Route path="*" element={<Navigate to={ROUTE_ENDPOINTS.LANDING} />} />
        </Routes>
      </BrowserRouter>
    </Box>
  );
}
